import { FormProps } from "antd";
import { css } from "styled-components";

export const defaultPropsForm: FormProps = {
  layout: "vertical",
  requiredMark: false,
};

export const defaultPropsFormRequire: FormProps = {
  layout: "vertical",
  requiredMark: true,
};

export const formStyle = css`
  .ant-form-item-required::before {
    content: "*";
    margin-left: -8px;
    color: red;
    order: 1;
  }

  .ant-form-item-label {
    display: flex;
    width: 100%;
  }
`;
